import { Unstable_Grid2 as Grid, Alert, Stack } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { Switches, TextField } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';

import { MarketingContentFormValuesPaths } from './types';

export const OfferTrackingSection = () => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Tracking ID</Typography>
      </Grid>

      <Grid xs={12} sm={3}>
        <TextField
          name={'offer.trackingId' satisfies MarketingContentFormValuesPaths}
          label='Tracking ID'
        />
      </Grid>

      <Grid xs={12} sm={9}>
        <Stack direction='row' spacing={1} alignItems='center' height='100%'>
          <Switches
            name={'offer.includeActivityLogsInAltriaDDM' satisfies MarketingContentFormValuesPaths}
            data={{}}
          />
          <Typography variant='body1' fontWeight={500}>
            Include in monthly DDM report file submission
          </Typography>
        </Stack>
      </Grid>

      <Grid xs={12}>
        <Alert severity='info' icon={<InfoOutlinedIcon />}>
          To include this offer in Altria Digital Data Metric (DDM) files, the offer must be visible
          to members in the app
        </Alert>
      </Grid>
    </Grid>
  );
};
